/**
 * Environment types.
 */
export enum EnvironmentType {
  PROD = "PROD", // Production firebase project and remote production API and Beehive.
  LOCAL_PROD = "LOCAL_PROD", // Production firebase project and local API and Beehive.
  LOCAL_STAGING = "LOCAL_STAGING", // Staging firebase project and local API and Beehive.
}
